
class EventsHelper {
  Trigger(eventName, data) {
    const event = new CustomEvent(eventName, { detail: data });
    document.dispatchEvent(event);
  }

  On(eventName, callback) {
    if (!callback) { return; }
    document.addEventListener(eventName, callback);
  }

  AjaxModuleLoaded() {
    let event = new Event('ajax-module-loaded');
    document.dispatchEvent(event);
  }

  OnAjaxModuleLoaded(callback) {
    if (!callback) { return; }
    document.addEventListener("ajax-module-loaded", callback);
  }

  ReloadCarousels() {
    let event = new Event('reload-carousels');
    document.dispatchEvent(event);
  }

  OnReloadCarousels(callback) {
    if (!callback) { return; }
    document.addEventListener("reload-carousels", callback);
  }

  BeforeMatchDay() {
    let event = new Event('before-match-day');
    document.dispatchEvent(event);
  }

  OnBeforeMatchDay(callback) {
    if (!callback) { return; }
    document.addEventListener("before-match-day", callback);
  }

  AfterMatchDay() {
    let event = new Event('after-match-day');
    document.dispatchEvent(event);
  }

  OnAfterMatchDay(callback) {
    if (!callback) { return; }
    document.addEventListener("after-match-day", callback);
  }

  GlobalScheduleWeeklyNavChange(fromDate, toDate) {
    let event = new CustomEvent('gs-calendar-nav-date-changed', {
      "detail": { "fromDate": fromDate, "toDate": toDate }
    });
    document.dispatchEvent(event);
  }

  OnGlobalScheduleWeeklyNavChange(callback) {
    if (!callback) { return; }
    document.addEventListener("gs-calendar-nav-date-changed", callback);
  }

  ContentReload() {
    let event = new Event('content-reload');
    document.dispatchEvent(event);
  }

  OnContentReload(callback) {
    if (!callback) { return; }
    document.addEventListener("content-reload", callback);
  }
}

EventsHelper = new EventsHelper();
export default EventsHelper;
